var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "12px",
    viewBox: "0 0 24 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AE7B2410-61E6-4C4E-9EC1-9F77CB8E3AF6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1-Components---Create-Blueprint-Component",
    transform: "translate(-735.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-link",
    transform: "translate(727.000000, 378.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5191489,0 L16.3404255,0 C15.7387877,0 15.2510638,0.535584598 15.2510638,1.19626168 C15.2510638,1.85693877 15.7387877,2.39252336 16.3404255,2.39252336 L18.5191489,2.39252336 C20.3240625,2.39252336 21.787234,3.99927716 21.787234,5.98130841 C21.787234,7.96333966 20.3240625,9.57009346 18.5191489,9.57009346 L16.3404255,9.57009346 C15.7387877,9.57009346 15.2510638,10.1056781 15.2510638,10.7663551 C15.2510638,11.4270322 15.7387877,11.9626168 16.3404255,11.9626168 L18.5191489,11.9626168 C21.5273382,11.9626168 23.9659574,9.28469383 23.9659574,5.98130841 C23.9659574,2.67792299 21.5273382,0 18.5191489,0 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62553191,0 L5.44680851,0 C2.43861923,0 7.25660666e-16,2.67792299 7.25660666e-16,5.98130841 C7.25660666e-16,9.28469383 2.43861923,11.9626168 5.44680851,11.9626168 L7.62553191,11.9626168 C8.22716977,11.9626168 8.71489362,11.4270322 8.71489362,10.7663551 C8.71489362,10.1056781 8.22716977,9.57009346 7.62553191,9.57009346 L5.44680851,9.57009346 C3.64189495,9.57009346 2.1787234,7.96333966 2.1787234,5.98130841 C2.1787234,3.99927716 3.64189495,2.39252336 5.44680851,2.39252336 L7.62553191,2.39252336 C8.22716977,2.39252336 8.71489362,1.85693877 8.71489362,1.19626168 C8.71489362,0.535584598 8.22716977,0 7.62553191,0 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53617021,5.98130841 C6.53617021,6.6419855 7.02389406,7.17757009 7.62553191,7.17757009 L16.3404255,7.17757009 C16.9420634,7.17757009 17.4297872,6.6419855 17.4297872,5.98130841 C17.4297872,5.32063133 16.9420634,4.78504673 16.3404255,4.78504673 L7.62553191,4.78504673 C7.02389406,4.78504673 6.53617021,5.32063133 6.53617021,5.98130841 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkIcon.edfec65865aff26b2a8d45155c6a4573.svg";